import React, { useState } from 'react';
import { Button, Form, Modal } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';
import FormComponent from './FormComponent';

const AddComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const { REGION, AUTH } = useStore();
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);
	const [fileLists, setFileLists] = useState();

	const handleSubmit = async (data) => {
		setSaving(true);
		try {
			const response = await REGION.addRegion(data);

			if (fileLists) {
				const formData = new FormData();
				formData.append('RefTablename', 'region');
				formData.append('ERefRecordid', response.data);
				formData.append('Imagefile', fileLists[0]);
				formData.append('Description', data.regionName);
				formData.append('ImageType', 4);
				formData.append('isApproved', true);
				await AUTH.ImageUpload(formData);
			}
			if (response.httpStatusCode === 200) {
				Notification.success({
					message: 'Region Added successfully!',
				});
			}
			setFileLists(null);
			closeModal();
		} catch (error) {
			Notification.error({
				message: 'Error adding region ',
			});
		} finally {
			setSaving(false);
		}
	};

	const handleChange = async (s) => {
		form.validateFields({ validateOnly: true })
			.then(() => {
				setDisabled(false);
			})
			.catch(() => {
				setDisabled(true);
			});
	};

	const closeModal = () => {
		setDisabled(true);
		form.resetFields();
		REGION.regionDetail = null;
		setFileLists(null);
		onClose();
	};
	return (
		<Modal
			title="Add Region"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'500px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="AddForm"
					>
						Add Region
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<FormComponent
				id="AddForm"
				form={form}
				onFinish={handleSubmit}
				handleChange={handleChange}
				disabled={disabled}
				setFileLists={setFileLists}
				fileLists={fileLists}
			/>
		</Modal>
	);
});

export default AddComponent;
